import { render, staticRenderFns } from "./IntegrationFormApplicationData.vue?vue&type=template&id=8208139a&scoped=true&"
import script from "./IntegrationFormApplicationData.vue?vue&type=script&lang=ts&"
export * from "./IntegrationFormApplicationData.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationFormApplicationData.vue?vue&type=style&index=0&id=8208139a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8208139a",
  null
  
)

export default component.exports